import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { capitalize } from "../utilities/capitalize";
import * as Styled from "./Badge.styled";
export const Badge = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { attachedTo, children, colorVariant = "dark", hasBorder, hasShadow, offset, palette = "expressiveNeutral", variant = "rounded", ...otherProps } = props;
    const BadgeElement = variant === "bullet" ? Styled.BulletBadge : Styled.Badge;
    return (_jsx(BadgeElement, { ref: ref, "data-testid": "Badge", attachedTo: attachedTo, hasBorder: hasBorder, hasShadow: hasShadow, offset: offset, palette: palette, colorScheme: `alchemy${capitalize(colorVariant)}`, variant: variant, ...otherProps, children: children }));
});
Badge.displayName = "Badge";
Badge.defaultProps = {
    colorVariant: "dark",
    palette: "expressiveNeutral",
    variant: "rounded"
};
